<template>
  <!-- MODAL -->
  <TransitionRoot as="template" :show="open">
    <Dialog class="relative z-50" @close="closeDialog">
      <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100" leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
        <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
      </TransitionChild>

      <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95" enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200" leave-from="opacity-100 translate-y-0 sm:scale-100" leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
            <DialogPanel class="relative transform overflow-hidden rounded-lg bg-white px-8 pb-8 pt-6 text-left shadow-xl transition-all sm:my-8 sm:w-full lg:max-w-4xl sm:p-6">
              <!-- Conteiner de título e botão de fechar -->
              <div class="flex justify-between items-start">
                <h2 class="text-xl font-bold leading-9 tracking-tight text-gray-900">{{ title }}</h2>
                <button @click="closeDialog" type="button" class="text-gray-400 hover:text-gray-600 -mt-4">
                  <span class="sr-only">Fechar</span>
                  <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>
              <!-- Formulário principal com flex -->
              <div class="mt-4">
                <div class="grid grid-cols-2 gap-4">
                  <!-- Divider do Proponente -->
                  <div class="col-span-2 mt-10 mb-5">
                    <div class="relative">
                      <div class="absolute inset-0 flex items-center" aria-hidden="true">
                        <div class="w-full border-t border-gray-300"></div>
                      </div>
                      <div class="relative flex justify-start">
                        <span class="bg-white px-2 font-semibold text-blue-700">
                          Dados do Proponente {{ proposta?.dependente?.nome || proposta?.segurado?.nome || '' }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-1">Nome do Proponente</label>
                    <input :value="proposta?.dependente?.nome || proposta?.segurado?.nome || ''" readonly class="block w-full border-0 border-b border-gray-300 py-2 pl-2 pr-2 text-sm text-gray-900 focus:ring-0 focus:border-blue-400"/>
                  </div>

                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-1">Estado Civil</label>
                    <input :value="proposta?.proponente_estado_civil" readonly class="block w-full border-0 border-b border-gray-300 py-2 pl-2 pr-2 text-sm text-gray-900 focus:ring-0 focus:border-blue-400"/>
                  </div>

                  <div class="grid grid-cols-2 gap-4">
                    <div>
                      <label class="block text-sm font-medium text-gray-700 mb-1">Sexo</label>
                      <input :value="proposta?.proponente_sexo" readonly class="block w-full border-0 border-b border-gray-300 py-2 pl-2 pr-2 text-sm text-gray-900 focus:ring-0 focus:border-blue-400"/>
                    </div>
                    
                    <div>
                      <label class="block text-sm font-medium text-gray-700 mb-1">Filhos</label>
                      <input :value="proposta?.proponente_filhos" readonly class="block w-full border-0 border-b border-gray-300 py-2 pl-2 pr-2 text-sm text-gray-900 focus:ring-0 focus:border-blue-400"/>
                    </div>
                  </div>
                  
                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-1">Data de Admissão</label>
                    <input :value="proposta?.proponente_admissao" readonly class="block w-full border-0 border-b border-gray-300 py-2 pl-2 pr-2 text-sm text-gray-900 focus:ring-0 focus:border-blue-400"/>
                  </div>

                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-1">Salário</label>
                    <input :value="proposta?.proponente_salario" readonly class="block w-full border-0 border-b border-gray-300 py-2 pl-2 pr-2 text-sm text-gray-900 focus:ring-0 focus:border-blue-400"/>
                  </div>

                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-1">Nacionalidade</label>
                    <input :value="proposta?.proponente_nacionalidade" readonly class="block w-full border-0 border-b border-gray-300 py-2 pl-2 pr-2 text-sm text-gray-900 focus:ring-0 focus:border-blue-400"/>
                  </div>
                <!-- Divider Apolices -->
                  <div class="col-span-2 mt-10 mb-5">
                    <div class="relative">
                      <div class="absolute inset-0 flex items-center" aria-hidden="true">
                        <div class="w-full border-t border-gray-300"></div>
                      </div>
                      <div class="relative flex justify-start">
                        <span class="bg-white px-2 font-semibold text-blue-700">
                          Apolices
                        </span>
                      </div>
                    </div>
                  </div>
                  
                  <div class="flex-1 min-w-[300px] sm:min-w-[300px] lg:w-1/2">
                    <label for="apolice_search" class="block text-sm font-medium leading-6 text-gray-900">
                      Apólice
                    </label>

                    <input
                      id="apolice_search"
                      type="text"
                      v-model="apoliceQuery"
                      @input="onSearchApolice"
                      autocomplete="off"
                      class="mt-2 block w-full rounded-md border-0 py-1.5 px-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                      placeholder="Digite pelo menos 4 letras..."
                    />

                    <!-- Lista simples -->
                    <div
                      v-if="apoliceQuery?.trim()?.length >= 4 && apoliceResults.length"
                      class="mt-2 rounded-md shadow-sm ring-1 ring-inset ring-gray-300 bg-white overflow-hidden"
                    >
                      <button
                        v-for="item in apoliceResults"
                        :key="item.id"
                        type="button"
                        @click="selectApolice(item)"
                        class="w-full text-left px-3 py-2 text-sm text-gray-900 hover:bg-gray-50"
                      >
                        {{ item.nome }}
                      </button>
                    </div>
                    <p
                      v-else-if="apoliceQuery?.trim()?.length >= 4 && !apoliceResults.length"
                      class="mt-2 text-xs text-gray-500"
                    >
                      Nenhuma apólice encontrada.
                    </p>
                    <!-- ID real selecionado -->
                    <input type="hidden" v-model="data.apolice_id" />
                  </div>
                 <div class="col-span-2">
                    <div class="rounded-lg border border-gray-200 bg-white shadow-sm p-4">
                      <div class="flex items-center justify-between mb-4">
                        <h3 class="text-sm font-semibold text-gray-900">Ações</h3>
                        <span class="text-xs text-gray-500">Proposta / Documentos</span>
                      </div>

                      <div class="grid grid-cols-1 sm:grid-cols-2 gap-3">
                        <!-- Gestão da Proposta -->
                        <div class="rounded-md border border-gray-100 bg-gray-50 p-3">
                          <p class="text-xs font-semibold text-gray-700 mb-2">Gestão da Proposta</p>

                          <div class="flex flex-col gap-2">
                            <button
                              @click="openSolicitacao('criar')"
                              type="button"
                              class="bg-customPurple text-white text-sm px-4 py-1.5 rounded-md hover:bg-sienaBlue text-left"
                            >
                              Solicitação
                            </button>

                            <button
                              @click="modalDocumentoAberto = true"
                              type="button"
                              class="bg-customPurple text-white text-sm px-4 py-1.5 rounded-md hover:bg-sienaBlue text-left"
                            >
                              Enviar Arquivos
                            </button>
                          </div>
                        </div>

                        <!-- Assinatura & Documentos -->
                        <div class="rounded-md border border-gray-100 bg-gray-50 p-3">
                          <p class="text-xs font-semibold text-gray-700 mb-2">Assinatura & Documentos</p>

                          <div class="flex flex-col gap-2">
                            <button
                              @click="gerarDocumento"
                              type="button"
                              class="bg-customPurple text-white text-sm px-4 py-1.5 rounded-md hover:bg-sienaBlue text-left"
                            >
                              Gerar Documento para Assinatura
                            </button>

                            <button
                              @click="notificar"
                              type="button"
                              class="bg-customPurple text-white text-sm px-4 py-1.5 rounded-md hover:bg-sienaBlue text-left"
                            >
                              Enviar para assinatura
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- Divider Solicitações -->
                  <div class="col-span-2 mt-10 mb-5">
                    <div class="relative">
                      <div class="absolute inset-0 flex items-center" aria-hidden="true">
                        <div class="w-full border-t border-gray-300"></div>
                      </div>
                      <div class="relative flex justify-start">
                        <span class="bg-white px-2 font-semibold text-blue-700">
                         Solicitações
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="col-span-2">
                    <div class="max-h-72 overflow-y-auto">
                      <SolicistacoesList
                        :solicitacoes="proposta.solicitacao"
                        @handle-request="handleRequest"
                        @cancel-request="handleRequest"
                      />
                    </div>
                  </div>
                  <!-- Divider de linha temporal-->
                  <div class="col-span-2 mt-10 mb-5">
                    <div class="relative">
                      <div class="absolute inset-0 flex items-center" aria-hidden="true">
                        <div class="w-full border-t border-gray-300"></div>
                      </div>
                      <div class="relative flex justify-start">
                        <span class="bg-white px-2 font-semibold text-blue-700">
                          Linha Temporal da Proposta
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="col-span-2">
                      <PropostaTimeline
                        :timeline="proposta.timeline"
                      />   
                  </div>
                  <!-- Divider de linha temporal-->
                  <div class="col-span-2 mt-10 mb-5">
                    <div class="relative">
                      <div class="absolute inset-0 flex items-center" aria-hidden="true">
                        <div class="w-full border-t border-gray-300"></div>
                      </div>
                      <div class="relative flex justify-start">
                        <span class="bg-white px-2 font-semibold text-blue-700">
                          Documentos Solicitados
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="col-span-2">
                      <PropostaDocumentosPersonalizados
                        :docs="proposta.docs"
                      />   
                  </div>
                  <!-- Divider Dados de Endereço -->
                  <div class="col-span-2 mt-10 mb-5">
                    <div class="relative">
                      <div class="absolute inset-0 flex items-center" aria-hidden="true">
                        <div class="w-full border-t border-gray-300"></div>
                      </div>
                      <div class="relative flex justify-start">
                        <span class="bg-white px-2 font-semibold text-blue-700">
                          Dados de Endereço
                        </span>
                      </div>
                    </div>
                  </div>
                  
                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-1">Endereço</label>
                    <input :value="proposta?.proponente_endereco" readonly class="block w-full border-0 border-b border-gray-300 py-2 pl-2 pr-2 text-sm"/>
                  </div>

                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-1">Bairro</label>
                    <input :value="proposta?.proponente_bairro" readonly class="block w-full border-0 border-b border-gray-300 py-2 pl-2 pr-2 text-sm"/>
                  </div>

                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-1">Cidade</label>
                    <input :value="proposta?.proponente_cidade" readonly class="block w-full border-0 border-b border-gray-300 py-2 pl-2 pr-2 text-sm"/>
                  </div>

                  <!-- Divider Dados Financeiros e Plano -->
                  <div class="col-span-2 mt-10 mb-5">
                    <div class="relative">
                      <div class="absolute inset-0 flex items-center" aria-hidden="true">
                        <div class="w-full border-t border-gray-300"></div>
                      </div>
                      <div class="relative flex justify-start">
                        <span class="bg-white px-2 font-semibold text-blue-700">
                          Plano e Pagamento
                        </span>
                      </div>
                    </div>
                  </div>
                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-1">Plano</label>
                    <input :value="proposta?.plano?.nome" readonly class="block w-full border-0 border-b border-gray-300 py-2 pl-2 pr-2 text-sm"/>
                  </div>

                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-1">Empresa</label>
                    <input :value="proposta?.plano?.empresa_nome" readonly class="block w-full border-0 border-b border-gray-300 py-2 pl-2 pr-2 text-sm"/>
                  </div>

                  <div class="grid grid-cols-2 gap-4">
                    <div>
                      <label class="block text-sm font-medium text-gray-700 mb-1">Forma de Pagamento</label>
                      <input :value="proposta?.forma_pagamento" readonly class="block w-full border-0 border-b border-gray-300 py-2 pl-2 pr-2 text-sm"/>
                    </div>

                    <div>
                      <label class="block text-sm font-medium text-gray-700 mb-1">Periodicidade</label>
                      <input :value="proposta?.periodicidade_pagamento" readonly class="block w-full border-0 border-b border-gray-300 py-2 pl-2 pr-2 text-sm"/>
                    </div>

                    <div>
                      <label class="block text-sm font-medium text-gray-700 mb-1">Capital</label>
                      <input :value="proposta?.capital" readonly class="block w-full border-0 border-b border-gray-300 py-2 pl-2 pr-2 text-sm"/>
                    </div>
                  </div>

                  <div class="grid grid-cols-3 gap-4">
                    <div>
                      <label class="block text-sm font-medium text-gray-700 mb-1">Prêmio Líquido</label>
                      <input :value="proposta?.premio_liquido" readonly class="block w-full border-0 border-b border-gray-300 py-2 pl-2 pr-2 text-sm"/>
                    </div>
                    <div>
                      <label class="block text-sm font-medium text-gray-700 mb-1">IOF</label>
                      <input :value="proposta?.valor_iof" readonly class="block w-full border-0 border-b border-gray-300 py-2 pl-2 pr-2 text-sm"/>
                    </div>
                    <div>
                      <label class="block text-sm font-medium text-gray-700 mb-1">Prêmio Total</label>
                      <input :value="proposta?.premio_total" readonly class="block w-full border-0 border-b border-gray-300 py-2 pl-2 pr-2 text-sm"/>
                    </div>
                  </div>
                  <!-- Divider Beneficiários -->
                  <div class="col-span-2 mt-10 mb-5">
                    <div class="relative">
                      <div class="absolute inset-0 flex items-center" aria-hidden="true">
                        <div class="w-full border-t border-gray-300"></div>
                      </div>
                      <div class="relative flex justify-start">
                        <span class="bg-white px-2 font-semibold text-blue-700">
                          Beneficiários
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="col-span-2">
                    <div v-if="proposta?.beneficiarios?.length" class="space-y-4 mt-4">
                      <div
                        v-for="(beneficiario, index) in proposta.beneficiarios"
                        :key="index"
                        class="bg-gray-50 p-4 rounded-lg shadow-md"
                      >
                        <p><strong>Nome:</strong> {{ beneficiario.nome }}</p>
                        <p><strong>CPF:</strong> {{ beneficiario.cpf }}</p>
                        <p><strong>Parentesco:</strong> {{ beneficiario.grau_parentesco }}</p>
                        <p><strong>Participação (%):</strong> {{ beneficiario.percentual_participacao }}</p>
                      </div>
                    </div>
                  </div>

                  <div v-for="(grupo, gIndex) in proposta.perguntas" :key="gIndex" class="col-span-2">
                    <!-- Divider com nome do grupo -->
                    <div class="col-span-2 mt-10 mb-5">
                      <div class="relative">
                        <div class="absolute inset-0 flex items-center" aria-hidden="true">
                          <div class="w-full border-t border-gray-300"></div>
                        </div>
                        <div class="relative flex justify-start">
                          <span class="bg-white px-2 font-semibold text-blue-700">
                            {{ grupo.grupo }}
                          </span>
                        </div>
                      </div>
                    </div>
                    <!-- Bloco de perguntas -->
                    <div
                      class="w-full p-4 bg-white rounded-lg shadow-md border border-gray-200 grid grid-cols-2 gap-6 col-span-2"
                    >
                      <div
                        v-for="(pergunta, pIndex) in grupo.perguntas"
                        :key="pIndex"
                        class="space-y-2"
                      >
                        <!-- Pergunta -->
                        <p class="font-medium text-gray-700">
                          {{ pergunta.pergunta }}
                        </p>

                        <!-- Respostas -->
                        <div v-for="(resp, rIndex) in pergunta.respostas" :key="rIndex" class="flex items-center space-x-2">
                          <span v-if="resp.subgrupo" class="text-sm text-gray-500 min-w-[100px]">
                            {{ resp.subgrupo }}:
                          </span>

                          <template v-if="pergunta.tipo === 'valor'">
                            <span class="text-gray-800">{{ resp.resposta ?? '-' }}</span>
                          </template>

                          <template v-else-if="pergunta.tipo === 'checkbox_sim'">
                            <input
                              type="checkbox"
                              class="h-4 w-4 text-blue-600 border-gray-300 rounded cursor-not-allowed"
                              :checked="resp.resposta"
                              disabled
                            />
                          </template>

                          <template v-else-if="pergunta.tipo === 'checkbox_sim_nao'">
                            <div class="flex items-center space-x-4">
                              <label class="flex items-center space-x-1">
                                <input
                                  type="checkbox"
                                  class="h-4 w-4 text-blue-600 border-gray-300 rounded cursor-not-allowed"
                                  :checked="resp.resposta.sim"
                                  disabled
                                />
                                <span class="text-sm">Sim</span>
                              </label>
                              <label class="flex items-center space-x-1">
                                <input
                                  type="checkbox"
                                  class="h-4 w-4 text-blue-600 border-gray-300 rounded cursor-not-allowed"
                                  :checked="resp.resposta.nao"
                                  disabled
                                />
                                <span class="text-sm">Não</span>
                              </label>
                            </div>
                          </template>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- Divider Status documento -->
                  <div class="col-span-2 mt-10 mb-5">
                    <div class="relative">
                      <div class="absolute inset-0 flex items-center" aria-hidden="true">
                        <div class="w-full border-t border-gray-300"></div>
                      </div>
                      <div class="relative flex justify-start">
                        <span class="bg-white px-2 font-semibold text-blue-700">
                          Status do Documento para assinatura
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="w-full p-4 bg-white rounded-lg shadow-md border border-gray-200 space-y-2 col-span-2">

                    <p><strong>Status: </strong>
                      <span
                        :class="{
                          'text-yellow-600': proposta?.documento_clicksign?.status === 'running',
                          'text-green-600': proposta?.documento_clicksign?.status === 'signed',
                          'text-red-600': proposta?.documento_clicksign?.status === 'refused',
                          'text-gray-600': !proposta?.documento_clicksign?.status
                        }"
                      >
                        {{ proposta?.documento_clicksign?.status || 'Indefinido' }}
                      </span>
                    </p>

                    <p><strong>Envelope ID:</strong> {{ proposta?.documento_clicksign?.envelope_id }}</p>
                    <p><strong>Document ID:</strong> {{ proposta?.documento_clicksign?.document_id }}</p>
                    <p><strong>Signer ID:</strong> {{ proposta?.documento_clicksign?.signer_id }}</p>

                    <a
                      v-if="proposta?.documento_clicksign?.clicksign_document_url"
                      :href="proposta.documento_clicksign.clicksign_document_url"
                      target="_blank"
                      class="inline-block mt-2 text-sm text-blue-600 hover:underline"
                    >
                      Visualizar Documento
                    </a>
                  </div>
                </div>
                <SolicitacaoForm
                  :tipoFormSolicitacao="tipoFormSolicitacao"
                  :proposta="proposta"
                  :open="solicitacaoOpen"
                  @create-new-request="createResquest"
                  @create-new-response="createResponse"
                  @cancel-request="cancelRequest"
                  @close="solicitacaoOpen = false"
                  @update-open="solicitacaoOpen = false"
                />
                <PropostaDocumentoUpload
                  :open="modalDocumentoAberto"
                  @upload-documento="enviarDocumentoProposta"
                  @update-open="modalDocumentoAberto = $event"
                />
              </div>
            </DialogPanel>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script>

import { Dialog, DialogPanel, TransitionChild, TransitionRoot } from '@headlessui/vue';
import SolicitacaoForm from './SolicitacaoForm.vue';
import SolicistacoesList from './SolicistacoesList.vue';
import PropostaTimeline from './PropostaTimeline.vue';
import PropostaDocumentoUpload from './PropostaDocumentoUpload.vue';
import PropostaDocumentosPersonalizados from './PropostaDocumentosPersonalizados.vue';
import ApolicesRepository from '@/services/ApolicesRepository.vue';
import { handleUnauthorized } from '@/services/AuthSer/authServiceFunction';
import { pageVariables } from '@/views/insideviews/propostas/PageVariablesPropostas';
import debounce from 'lodash/debounce';
import Swal from "sweetalert2";
  export default {
    name: 'PropostasForm',
    emits:['update-open','create-request','create-response','cancel-response-request','proposta-file','create-file'],
    async created(){
      this.buscarApolices = debounce((...args) => {
        this._buscarApolices(...args);
      }, 400);
    },
    props: {
      title: {
        type: String,
        required: true
      },
      open: {
        type: Boolean,
        required: true
      },
      resetFormData:{
        type: Boolean,
        required:true
      },
      proposta:{
        type:Object,
        required:true
      }
    },  
    watch: {
      resetFormData(newValue) { 
        if(newValue == true){
          this.data = {}
        }
      }
    }, 
    data() {
      return {
        ...pageVariables,
        data:{},
        apoliceQuery: "",
        apoliceResults: [],
        apoliceTimer: null,
        solicitacaoOpen: false,
        tipoFormSolicitacao:'',
        solicitacaoId:'',
        modalDocumentoAberto:false,
        apoliceData:{},
        onlineUser: JSON.parse(window.localStorage.getItem("myUser")),
      };
    },
    methods: {
      closeDialog() {
        this.$emit('update-open', false);
      },
      openSolicitacao(tipo){
        this.tipoFormSolicitacao = tipo;
        this.solicitacaoOpen = true;
      },
      createResquest(data){
        this.$emit('create-request', data); 
      },
      createResponse(data){
        data.id = this.solicitacaoId;
        const payload = {
          id: this.solicitacaoId,
          proposta_id: data.proposta_id,
          resposta: data.resposta
        }
        this.$emit('create-response', payload); 
      },
      cancelRequest(data){
        data.id = this.solicitacaoId;
        console.log(data)
        const payload = {
          id: this.solicitacaoId,
          proposta_id: data.proposta_id,
          motivo_cancelamento: data.motivo_cancelamento
        }
        this.$emit('cancel-response-request', payload); 
      },
      getDoencaColorClass(doenca) {
        switch (doenca) {
          case 'Câncer':
            return 'bg-red-100 text-red-800';
          case 'Doença Cardíaca':
            return 'bg-blue-100 text-blue-800';
          case 'Diabetes':
            return 'bg-green-100 text-green-800';
          case 'HIV / Aids, Hepatite B ou C':
            return 'bg-pink-100 text-pink-800';
          case 'Doença Neurológica':
            return 'bg-purple-100 text-purple-800';
          case 'Transtorno Psiquiátrico':
            return 'bg-yellow-100 text-yellow-800';
          default:
            return 'bg-gray-100 text-gray-700';
        }
      },
      handleRequest(data){
        this.solicitacaoId = data.id;
        console.log(data)
        this.openSolicitacao(data.tipo)
      },
      enviarDocumentoProposta(data){
        const payload = {
          proposta_id: this.proposta.id,
          tipo_documento: data.tipo_documento,
          arquivo_base64: data.base64
        }
        this.$emit('proposta-file', payload);
      },
      notificar(){
        this.$emit('send-notification', this.proposta.id);
      },
      gerarDocumento(){
        this.$emit('create-file', this.proposta.id);
      },
      onSearchApolice() {
        this.data.apolice_id = null; 
        this.buscarApolices();
      },

      async _buscarApolices() {
        const q = (this.apoliceQuery || "").trim();

        if (q.length < 4) {
          this.apoliceResults = [];
          return;
        }

        const apolicesRepo = new ApolicesRepository();
        try {
          const response = await apolicesRepo.searchApolices(
            this.searchPage, 
            this.onlineUser.token,
            q
          );
         
          if (response?.status === 200) {
            this.apoliceResults = response.data || [];
          } else {
            this.apoliceResults = [];
            this.error = response?.message;
          }
          } catch (error) {
            this.apoliceResults = [];
            handleUnauthorized(error);
          }
        },

        selectApolice(item) {
          this.apoliceData.apolice_id = item.id;
          this.apoliceQuery = item.nome;
          this.apoliceResults = [];
          Swal.fire({
            icon: 'warning',
            title: 'Confirmar vínculo',
            text: 'Você tem certeza que quer vincular essa apólice à proposta?',
            showCancelButton: true,
            confirmButtonText: 'Sim, vincular',
            cancelButtonText: 'Cancelar',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#6b7280', // cinza (tailwind gray-500-ish)
            reverseButtons: true,
          }).then((result) => {
            if (result.isConfirmed) {
              this.vincularApolice();
            } else {
              // opcional: desfaz seleção se cancelar
              // this.data.apolice_id = null;
              // this.apoliceQuery = '';
            }
          });
        },

        async vincularApolice(){
          this.loading = true; 
          const apoliRepo = new ApolicesRepository();
          try {
            const response = await apoliRepo.apoliceSegurado(this.page,this.onlineUser.token,this.proposta.id,this.apoliceData);
            if (response?.status === 201) {
              this.mostrarAlerta();
              this.loading = false; 
            } else {
              this.error = response?.message;
              this.mostrarAlertaErro(this.error);
              this.loading = false;
            }
          } catch (error) {
            this.mostrarAlertaErro(error.message);
            handleUnauthorized(error);
            this.loading = false; 
          }	
        },
        mostrarAlerta() {
          Swal.fire({
            icon: 'success',
            title: 'Sucesso!',
            text: 'A operação foi concluída com sucesso.',
            confirmButtonColor: '#3085d6', 
          });
        },

        mostrarAlertaErro(message) {
          Swal.fire({
            icon: 'error',
            title: 'Erro!',
            text: message,
            confirmButtonColor: '#3085d6', 
          });
        },
    },
    components:{
      Dialog,
      DialogPanel, 
      TransitionChild, 
      TransitionRoot,
      SolicitacaoForm,
      SolicistacoesList,
      PropostaTimeline,
      PropostaDocumentoUpload,
      PropostaDocumentosPersonalizados
    },
  }
</script>